// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tree-counter[data-v-33581eb8]{display:flex;flex-wrap:wrap;justify-content:center}.tree-counter li[data-v-33581eb8]{background-color:#cdfd4f;border-radius:.5rem;color:#172714;font-size:6vw;line-height:1;margin:.375rem .6vw;padding:.75rem;text-align:center}.tree-counter li.disabled[data-v-33581eb8]{opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
